import { storeLocalToken } from '../services/storage';
import type { AccessToken, RefreshToken } from '../types/auth';

export const NATIVE_URL_SCHEME = 'graphdebate';
export const DEEP_LINK_AUTH_REDIRECT_URL = `${NATIVE_URL_SCHEME}://auth-callback`;
export const DEEP_LINK_AUTH_REDIRECT_DELAY = 500;

export const NOTIF_PENDING_LINK_KEY = '__PENDING_LINK__';
export const NOTIF_LINK_FLUSH_DELAY = 300;

/**
 * Check if the app is running in a native app (Capacitor webview)
 */
export const isNativeOpener = () => window['isNativeOpener'] === true;

/**
 * Get the deep link redirect url for the native app
 *
 * @param deepLinkRedirectUrlBase - The base url for the deep link redirect (default: graphdebate://auth-callback)
 * @param key - The key of the website
 * @param authResponse - The auth response
 * @returns The deep link redirect url
 */
export const finalizeNativeLogin = ({
  deepLinkRedirectUrlBase = 'graphdebate://auth-callback',
  key,
  token = '',
  refreshToken = '',
}: {
  deepLinkRedirectUrlBase?: string;
  key: string;
  token: AccessToken;
  refreshToken: RefreshToken;
}) => {
  storeLocalToken(key, token, refreshToken);

  const deepLinkRedirectUrl = `${deepLinkRedirectUrlBase}?token=${token}&refreshToken=${refreshToken}&key=${key}`;
  window.location.href = deepLinkRedirectUrl;
};
